/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardDto
 */
export interface DashboardDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardDto
     */
    readonly streak?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDto
     */
    readonly progress?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDto
     */
    readonly goal?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDto
     */
    readonly total?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardDto
     */
    readonly totalTime?: number;
}

/**
 * Check if a given object implements the DashboardDto interface.
 */
export function instanceOfDashboardDto(value: object): value is DashboardDto {
    return true;
}

export function DashboardDtoFromJSON(json: any): DashboardDto {
    return DashboardDtoFromJSONTyped(json, false);
}

export function DashboardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'streak': json['streak'] == null ? undefined : json['streak'],
        'progress': json['progress'] == null ? undefined : json['progress'],
        'goal': json['goal'] == null ? undefined : json['goal'],
        'total': json['total'] == null ? undefined : json['total'],
        'totalTime': json['totalTime'] == null ? undefined : json['totalTime'],
    };
}

export function DashboardDtoToJSON(json: any): DashboardDto {
    return DashboardDtoToJSONTyped(json, false);
}

export function DashboardDtoToJSONTyped(value?: Omit<DashboardDto, 'streak'|'progress'|'goal'|'total'|'totalTime'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

